import React, { useCallback, useRef, useState } from 'react';
import { ATMButton, ATMModal } from 'shared-it-appmod-ui';
import {
  ToastError,
  ToastSuccess,
} from 'src/components/atoms/toaster/toaster.component';
import Lang from 'src/libraries/language';
import { useOperatorPilotContext } from 'src/contexts/operator-pilot.context';
import { getOperatorPilotStatus } from 'src/selectors/operator-pilot.selector';
import { actionTypes } from 'src/ducks/operator-pilot.duck';
import { IOperatorPilotForm } from 'src/models/operator-pilot.model';
import OperatorPilotsForm from '../operator-pilot-relationship-form/operator-pilot-relationship-form.component';
import style from '../operator-pilot-relationship-list/operator-pilot-relationship-list.module.scss';

const OperatorPilotsAdd: React.FC = () => {
  const { state, actions } = useOperatorPilotContext();
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isDirty, setIsDirty] = useState(false);
  const formRef = useRef<HTMLFormElement>(null);

  const defaultValues = {
    operatorId: undefined,
    pilotId: undefined,
    opId: undefined,
  };

  const addStatus = getOperatorPilotStatus(
    state,
    actionTypes.OPERATOR_PILOT_ADD
  );

  const handleSave = useCallback(() => {
    if (formRef && formRef.current) {
      formRef.current.handleSubmit();
    }
  }, [formRef]);

  const handleSubmit = useCallback(
    async (data) => {
      const formData: IOperatorPilotForm = {
        operatorId: data.operatorId,
        pilotId: data.pilotId,
      };
      const response = await actions.addPOST(formData);
      if (!response.error) {
        ToastSuccess(Lang.MSG_OPERATOR_PILOT_ADD_SUCCESS);
      } else {
        ToastError(response.error.message);
      }
      setIsAddOpen(false);
      actions.listGET();
    },
    [actions, setIsAddOpen]
  );

  return (
    <ATMModal
      open={isAddOpen}
      size="tiny"
      trigger={
        <ATMButton
          basic
          color="blue"
          content={Lang.LBL_NEW}
          icon="plus"
          floated="right"
          onClick={() => setIsAddOpen(true)}
        />
      }
      header={Lang.LBL_ADD_OPERATOR_PILOT}
      content={
        <div className={style.content}>
          <OperatorPilotsForm
            defaultValues={defaultValues}
            formRef={formRef}
            handleSubmit={handleSubmit}
            handleEnable={(value) => setIsDirty(value)}
          />
        </div>
      }
      actions={
        <div className={style.actionBtns}>
          <ATMButton
            basic
            color="blue"
            content={Lang.LBL_CANCEL}
            onClick={() => {
              setIsAddOpen(false);
            }}
          />
          <ATMButton
            primary
            content={Lang.LBL_SAVE}
            disabled={!isDirty || addStatus.fetching}
            onClick={handleSave}
            loading={addStatus.fetching}
          />
        </div>
      }
    />
  );
};

export default OperatorPilotsAdd;
